import * as React from 'react';
import { CharacteristicGroupDataService, CharacteristicDataService, Auth } from '../../services';
import { Characteristic, CharacteristicGroup } from '../../models';
import { PVAPage } from '../../components';
import { BaseRouteProps, EditState, EditProps } from '../../interfaces';
import { CharacteristicGroupForm } from './CharacteristicGroupForm';
import { UserStore, FilterStore } from '../../stores';
import { Roles } from '../../stores/Constants';
import { inject, observer } from 'mobx-react';
import { computed } from 'mobx';
import { NavLink } from 'react-router-dom';

interface CharacteristicGroupEditState extends EditState<CharacteristicGroup> {
    originalEntity: CharacteristicGroup | undefined;
    characteristics: Characteristic[];
    open: boolean;
}

interface CharacteristicEditProps extends BaseRouteProps<EditProps> {
    UserStore?: UserStore;
    FilterStore?: FilterStore;
    Auth?: Auth;
}

@inject('UserStore', 'FilterStore', 'Auth') @observer
export class CharacteristicGroupEdit extends React.Component<CharacteristicEditProps, CharacteristicGroupEditState> {
    private characteristicGroupDataService = new CharacteristicGroupDataService(this.props.notificationService);
    private characteristicDataService = new CharacteristicDataService(this.props.notificationService);

    constructor(props: CharacteristicEditProps) {
        super(props);

        this.state = {
            originalEntity: undefined,
            characteristics: [],
            open: false
        };
    }

    public componentDidMount() {
        if (this.props.match.params.id) {
            this.characteristicGroupDataService.get(this.props.match.params.id)
                .then((characteristicGroup: CharacteristicGroup) => {
                    this.setState({
                        originalEntity: characteristicGroup
                    });

                    this.characteristicDataService.getAllByGroup(characteristicGroup)
                        .then((characteristics: Characteristic[]) => {
                            this.setState({
                                characteristics: characteristics
                            });
                        });
                });
        }
    }

    @computed get isSuperAdmin() {
        return this.props.Auth!.userRoleIn([Roles.SuperAdmin]);
    }

    private delete() {
        if (this.state.originalEntity && confirm('Are you sure you want to delete this characteristic group?')) {
            this.characteristicGroupDataService.delete(this.state.originalEntity).then(() => {
                if (this.state.originalEntity) {
                    this.props.history.push('/surveyversion/' + this.state.originalEntity.surveyVersionID + '/characteristicGroups');
                }
            });
        }
    }

    private ActionsButton() {
        return (
            <div className="btn-group dropdown">
                <button type="button" className="btn btn-primary"  onClick={(e) => this.setState({open: !this.state.open })}>
                    <span>Actions </span>
                    <span className="caret" />
                </button>
                <ul className={`action-menu dropdown-menu ${this.state.open ? 'open' : ''}`}>
                    {this.isSuperAdmin && <li className="options-header">Maintenance</li>}
                    {this.isSuperAdmin && <li className="options-entry" onClick={(e) => this.delete()}>
                        <div className="options-entry-title">
                            <span className="glyphicon glyphicon-delete" /> <span style={{color: 'red'}}> Delete Characteristic Group</span>
                        </div>
                        <div className="options-entry-desc">
                            This will soft delete the characteristic group from the system.
                        </div>
                    </li>}

                </ul>
        </div>);
    }

    public render() {
        if (this.state.originalEntity === undefined) {
            return <div />;
        }

        return (
            <PVAPage>
                <PVAPage.Header>
                    <PVAPage.Header.Buttons>
                        <NavLink to={'/surveyversion/' + this.state.originalEntity.surveyVersionID + '/characteristicgroups'}>
                            <span className="glyphicon glyphicon-arrow-left" />
                        </NavLink>
                        {this.isSuperAdmin && this.ActionsButton()}
                    </PVAPage.Header.Buttons>
                    <div className="title">
                        Characteristic Group Edit
                        {this.state.originalEntity.secondaryReport && <span className="light"> &nbsp; for report '{this.state.originalEntity.secondaryReport.name}'</span>}
                    </div>
                </PVAPage.Header>

                <PVAPage.Body>
                    <CharacteristicGroupForm defaultValues={this.state.originalEntity} surveyVersionId={this.state.originalEntity.surveyVersionID} notificationService={this.props.notificationService} submit={(e: any) => this.save(e)} />                    
                </PVAPage.Body>

                <PVAPage.Footer />
            </PVAPage>);
    }

    private save(values: any) {
        this.characteristicGroupDataService.update(values).then((result: CharacteristicGroup) => {
            this.props.history.push('/');
            this.props.history.push('/characteristicgroup/' + result.id);
        });
    }
}



// WEBPACK FOOTER //
// ./src/components/characteristicgroup/CharacteristicGroupEdit.tsx